import { render, staticRenderFns } from "./WorkflowDropdown.vue?vue&type=template&id=2a6bf063&scoped=true&"
import script from "./WorkflowDropdown.vue?vue&type=script&lang=js&"
export * from "./WorkflowDropdown.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowDropdown.vue?vue&type=style&index=0&id=2a6bf063&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6bf063",
  null
  
)

export default component.exports